import { useState, useEffect } from "react";
import { supabase } from "./supabase";
import { guardarNotificacion } from "./NotificadorALQOS";
import BotonMapaProceso from "./BotonMapaProceso";

const TAREAS_BASE = [
  { t:"Entrega de ropa de trabajo / EPP", quien:"rrhh" },
  { t:"Alta en AFIP / obra social", quien:"rrhh" },
  { t:"Apertura cuenta sueldo", quien:"rrhh" },
  { t:"Entrega de usuario y acceso a ALQOS", quien:"rrhh" },
  { t:"Lectura del reglamento interno", quien:"empleado" },
  { t:"Capacitación inicial de seguridad (H&S)", quien:"empleado" },
  { t:"Firma de confidencialidad", quien:"empleado" },
];

export default function Onboarding({ onVolver, oscuro, usuario, embebido }) {
  const [lista, setLista] = useState([]);
  const [empleados, setEmpleados] = useState([]);
  const [nuevoEmp, setNuevoEmp] = useState("");
  const [loading, setLoading] = useState(true);
  const esAdmin = usuario?.rol === "Administrador" || usuario?.rol === "RecursosHumanos";

  const C = { bg:oscuro?"#0a1129":"#F0EEFF", card:oscuro?"#0f1c3f":"#fff", navy:"#09184D", purple:"#7B5BF2", green:"#22c55e", amber:"#f59e0b", sub:"#808085", border:oscuro?"#1e3a8a":"#dde3f0", text:oscuro?"#EDF2FA":"#2F3E2E" };
  const inp = { width:"100%", padding:"10px 14px", borderRadius:"10px", border:`1.5px solid ${C.border}`, fontSize:"13px", boxSizing:"border-box", marginTop:"6px", background:oscuro?"#0a1129":"white", color:C.text };
  const card = { background:C.card, borderRadius:"14px", padding:"1.2rem", border:`1.5px solid ${C.border}`, marginBottom:"12px" };

  useEffect(() => { cargar(); }, []);

  const cargar = async () => {
    setLoading(true);
    try {
      const { data } = await supabase.from("onboarding").select("data").order("id", { ascending:false });
      setLista(data ? data.map(r => r.data) : []);
      const { data: emp } = await supabase.from("empleados").select("data");
      setEmpleados(emp ? emp.map(r => r.data) : []);
    } catch(e) { console.warn(e); }
    setLoading(false);
  };

  const crear = async () => {
    if (!nuevoEmp) { alert("Elegí un empleado."); return; }
    const emp = empleados.find(e => String(e.id)===String(nuevoEmp));
    if (lista.some(o => String(o.empleado_id)===String(emp.id))) { alert("Ese empleado ya tiene onboarding."); return; }
    const ob = { id:Date.now(), empleado_id:emp.id, empleado_nombre:emp.nombre, usuario_id:emp.usuario_id||emp.id, creado_por:usuario?.nombre, creado_at:new Date().toISOString(),
      tareas: TAREAS_BASE.map((x,i) => ({ id:i+1, t:x.t, quien:x.quien, hecho:false, fecha:null })) };
    const tenantId = Number(localStorage.getItem("alqos_tenant_id")) || null;
    try { await supabase.from("onboarding").upsert([{ id:ob.id, data:ob, tenant_id:tenantId }]); } catch(e) { console.warn(e); }
    guardarNotificacion({ modulo:"Empleado", destinatario_id:ob.usuario_id, tipo:"onboarding", titulo:"Tu onboarding está listo", mensaje:"Tenés tareas de ingreso para completar en tu portal." });
    setNuevoEmp(""); await cargar();
  };

  const toggle = async (ob, tareaId) => {
    const tareas = ob.tareas.map(t => t.id===tareaId ? { ...t, hecho:!t.hecho, fecha:!t.hecho?new Date().toISOString():null } : t);
    const upd = { ...ob, tareas };
    const tenantId = Number(localStorage.getItem("alqos_tenant_id")) || null;
    try { await supabase.from("onboarding").upsert([{ id:ob.id, data:upd, tenant_id:tenantId }]); } catch(e) { console.warn(e); }
    setLista(prev => prev.map(o => o.id===ob.id ? upd : o));
  };

  const sinOnboarding = empleados.filter(e => !lista.some(o => String(o.empleado_id)===String(e.id)));

  return (
    <div style={{ minHeight: embebido?"auto":"100vh", background: embebido?"transparent":C.bg, fontFamily:"sans-serif" }}>
      {!embebido && <div style={{ background:C.navy, padding:"1rem 1.5rem", display:"flex", alignItems:"center", gap:"12px", position:"sticky", top:0, zIndex:100 }}>
        <button onClick={onVolver} style={{ background:"rgba(255,255,255,0.1)", border:"none", color:"white", padding:"6px 14px", borderRadius:"10px", cursor:"pointer", fontSize:"13px" }}>← Volver</button>
        <span style={{ color:"white", fontWeight:"700", fontSize:"16px" }}>🚀 Onboarding</span>
        {usuario?.rol === "Administrador" && <BotonMapaProceso moduloKey="onboarding" oscuro={oscuro} />}
      </div>}
      <div style={{ padding:"1.5rem", maxWidth:"700px", margin:"0 auto" }}>
        {esAdmin && (
          <div style={card}>
            <h3 style={{ fontSize:"13px", fontWeight:"700", color:C.purple, marginBottom:"4px" }}>Iniciar onboarding</h3>
            <select value={nuevoEmp} onChange={e=>setNuevoEmp(e.target.value)} style={inp}>
              <option value="">Elegí un empleado...</option>
              {sinOnboarding.map(e => <option key={e.id} value={e.id}>{e.legajo} — {e.nombre}</option>)}
            </select>
            <button onClick={crear} style={{ width:"100%", marginTop:"12px", padding:"11px", background:C.purple, color:"white", border:"none", borderRadius:"10px", cursor:"pointer", fontSize:"14px", fontWeight:"700" }}>🚀 Crear checklist</button>
          </div>
        )}
        <h3 style={{ fontSize:"13px", fontWeight:"700", color:C.sub, margin:"20px 0 12px", textTransform:"uppercase" }}>En curso</h3>
        {loading && <p style={{ color:C.sub, textAlign:"center" }}>⏳ Cargando...</p>}
        {!loading && lista.length===0 && <p style={{ color:C.sub, textAlign:"center", padding:"2rem" }}>Sin onboardings</p>}
        {lista.map(ob => {
          const total = ob.tareas.length, hechas = ob.tareas.filter(t=>t.hecho).length;
          const pct = Math.round(hechas/total*100);
          return (
            <div key={ob.id} style={card}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"10px" }}>
                <p style={{ fontSize:"14px", fontWeight:"700", color:C.navy, margin:0 }}>{ob.empleado_nombre}</p>
                <span style={{ fontSize:"12px", fontWeight:"700", color:pct===100?C.green:C.amber }}>{pct}%</span>
              </div>
              <div style={{ height:"6px", background:C.border, borderRadius:"3px", marginBottom:"12px", overflow:"hidden" }}>
                <div style={{ width:`${pct}%`, height:"100%", background:pct===100?C.green:C.purple }}/>
              </div>
              {ob.tareas.map(t => (
                <div key={t.id} style={{ display:"flex", alignItems:"center", gap:"8px", padding:"6px 0", borderBottom:`0.5px solid ${C.border}` }}>
                  <button onClick={()=>(esAdmin||t.quien==="rrhh")?toggle(ob,t.id):null} disabled={!esAdmin&&t.quien!=="rrhh"}
                    style={{ width:"22px", height:"22px", borderRadius:"6px", border:`1.5px solid ${t.hecho?C.green:C.border}`, background:t.hecho?C.green:"transparent", color:"white", cursor:(esAdmin||t.quien==="rrhh")?"pointer":"default", fontSize:"12px", flexShrink:0 }}>{t.hecho?"✓":""}</button>
                  <span style={{ fontSize:"13px", color:t.hecho?C.sub:C.text, textDecoration:t.hecho?"line-through":"none", flex:1 }}>{t.t}</span>
                  <span style={{ fontSize:"9px", color:C.sub, background:t.quien==="rrhh"?"#eff6ff":"#f0fdf4", padding:"2px 6px", borderRadius:"5px" }}>{t.quien==="rrhh"?"RRHH":"Empleado"}</span>
                </div>
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
}
